// Composables
import { createRouter, createWebHistory, START_LOCATION } from "vue-router";
import rotasOs from "./rotas/OrdemServico";
import rotasPosVendas from "./rotas/PosVendas";
import rotasDiario from "./rotas/DiarioObra";
import rotasFabricacao from "./rotas/Fabricacao";
import { rotaContratoAberta, rotaContratoRestrita } from "./rotas/Contrato";
import { rotaComObra, rotaSemObra } from "./rotas/Materiais";
import rotasCRE from "./rotas/ProjetosEngenharia";
import rotasSGI from "./rotas/Sgi";
import rotasProduto from "./rotas/Produto";
import rotasApontamento from "@/modules/apontamentos/apontamentos.route";
import { rotaJuridico } from "./rotas/Juridico";
import useCounterStore from "@/store/user";
import { criarBreadcrumbs, verificarAcesso, ROTAS_IGNORADAS, converterHashFederado, filtrarRotasSeNecessario, redirecionarUltimaRota } from "./helpers"
export const rotasAbertas = [
  {
    path: "",
    name: "Home",
    props: true,
    component: () => import("@/views/Home.vue"),
    meta: {
      showMenu: false,
    },
  },
  {
    path: "/acessoFederado",
    name: "AcessoFederado",
    props: true,
    component: () => import("@/views/AcessoFederado.vue"),
    meta: {
      showMenu: false,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: {
      showMenu: false,
    },
  },
  {
    path: "/primeiroLogin",
    name: "PrimeiroLogin",
    component: () => import("@/views/PrimeiroLogin.vue"),
    props: (route: any) => ({ user: route.query.user, code: route.query.code }),
    meta: {
      showMenu: false,
    },
  },
  {
    path: "/e/checklist",
    name: "Ocorrências",
    component: () => import("@/views/Checklist/EvidenciasChecklist.vue"),
    title: "Ocorrências",
    meta: {
      title: "Ocorrências",
      showMenu: false,
    },
  },
  {
    path: "/403",
    name: "403",
    component: () => import("@/views/Error/403.vue"),
    meta: {
      showMenu: false,
    },
  },
  {
    path: "/ObraInacessivel",
    name: "ObraInacessivel",
    component: () => import("@/views/Error/ObraInacessivel.vue"),
    meta: {
      showMenu: false,
    },
  },
  {
    path: "/manutencao",
    name: "Manutencao",
    component: () => import("@/views/Error/Manutencao.vue"),
    meta: {
      showMenu: false,
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/Error/404.vue"),
    title: "404",
    meta: {
      title: "404",
      showMenu: false,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    nome: "naoEncontrado",
    redirect: "/404",
    component: 404,
    title: "naoEncontrado",
    meta: {
      title: "naoEncontrado",
      showMenu: false,
    },
  },
  {
    path: "/teste",
    layoutNome: "LayoutGeralAberto",
    component: () => import("@/layout/LayoutGeral.vue"),
    meta: {
      showMenu: false,
    },
    children: [
      {
        path: "/obras",
        name: "Obras",
        component: () => import("@/views/Obra/ObrasHome.vue"),
        title: "Início",
        meta: {
          title: "Início",
          acessoRapido: false,
          showMenu: false,
          emManutencao: false,
        },
      },
      {
        path: "/versoesSistema",
        name: "Versoes do Sistema",
        props: true,
        component: () => import("@/views/VersoesSistema.vue"),
        meta: {
          showMenu: false,
        },
      },
      {
        path: "/todas-obras",
        name: "Todas Obras",
        component: () => import("@/views/Obra/TodasObras.vue"),
        title: "Todas Obras",
        meta: {
          title: "Todas Obras",
          icon: "mdi-home-search-outline",
          subject: ["Obra"],
          acessoRapido: false,
          showMenu: true,
          emManutencao: false,
        },
      },
      {
        path: "/dashobras-obras",
        name: "Dashboard Obras",
        component: () => import("@/views/Obra/DashboardObras.vue"),
        title: "Dashboard Obras",
        meta: {
          title: "Dashboard Obras",
          icon: "mdi-view-sequential",
          subject: ["Obra"],
          action: ['seeAll'],
          acessoRapido: false,
          showMenu: true,
          emManutencao: false,
        },
      },
    ],
  },
];
export const rotasRestritas = [
  {
    path: "/obras/:obra",
    layoutNome: "LayoutObra",
    component: () => import("@/layout/LayoutObra.vue"),
    meta: {
      icon: "mdi-mdi-account",
      showMenu: false,
    },
    children: [
      {
        path: "",
        name: "Dashboard",
        component: () => import("@/views/Obra.vue"),
        meta: {
          obraObrigatoria: false,
          title: "Dashboard",
          icon: "mdi-view-dashboard-outline",
          showMenu: true,
        },
      },
      {
        path: "biblioteca",
        name: "Biblioteca De Obra",
        component: () => import("@/views/Biblioteca/BibliotecaObra.vue"),
        meta: {
          breadcrumb: "Dashboard",
          title: "Biblioteca de Obra",
          subject: ["BIBLIOTECA"],
          action: ["read"],
          icon: "mdi-bookshelf",
          showMenu: true,
        },
      },
      {
        path: "galeria",
        name: "Galeria de Obra",
        component: () => import("@/views/Obra/GaleriaObra.vue"),
        meta: {
          breadcrumb: "Dashboard",
          title: "Galeria de Obra",
          icon: "mdi-folder-multiple-image",
          subject: ["Obra"],
          action: ["read"],
          showMenu: true,
        },
      },
      {
        path: "usuarios/adicionar",
        name: "Adicionar Usuários",
        component: () => import("@/views/AdicionarUsuario.vue"),
        meta: {
          breadcrumb: "Adicionar Usuários",
          obraObrigatoria: true,
          title: "Adicionar Usuários",
          icon: "mdi-text-box-multiple-outline",
          subject: ["Usuario"],
          showMenu: true,
        },
      },
      {
        path: "atualizar",
        name: "Atualizar Obra",
        component: () => import("@/views/Obra/UpdateObra.vue"),
        meta: {
          breadcrumb: "Dashboard",
          title: "Atualizar Obra",
          icon: "mdi-pencil",
          subject: ["Obra"],
          action: ["update"],
          showMenu: true,
          grupo: "OBRA",
          grupoTitle: "Obra",
        },
      },
      {
        path: "informacoes",
        name: "Todas Informações",
        component: () => import("@/views/Obra/TodasInformacoes.vue"),
        meta: {
          title: "Todas Informações",
          breadcrumb: "Dashboard",
          icon: "mdi-plus",
          subject: ["Obra"],
          action: ["inspect"],
          showMenu: true,
          grupo: "OBRA",
          grupoTitle: "Obra",
        },
      },
      ...rotasCRE["obra"],
      ...rotaContratoRestrita,
      ...rotasOs,
      ...rotasDiario,
      ...rotaComObra,
    ],
  },
  ...rotasFabricacao,
  {
    path: "",
    layoutNome: "LayoutGeral",
    component: () => import("@/layout/LayoutGeral.vue"),
    meta: {
      showMenu: false,
    },
    children: [
      {
        path: "/usuarios/:user?",
        name: "Perfil",
        component: () => import("@/views/Perfil.vue"),
        meta: {
          title: "Perfil",
          subject: ["PERFIL"],
          icon: "mdi-account",
          showMenu: true,
        },
      },
      {
        path: "/biblioteca",
        name: "Biblioteca Gali",
        component: () => import("@/views/Biblioteca/BibliotecaGali.vue"),
        meta: {
          title: "Biblioteca",
          subject: ["BIBLIOTECA"],
          icon: "mdi-bookshelf",
          showMenu: true,
        },
      },
      {
        path: "/obra",
        name: "Nova Obra",
        component: () => import("@/views/Obra/NovaObra.vue"),
        meta: {
          title: "Nova Obra",
          icon: "mdi-plus",
          subject: ["Obra"],
          action: ["create"],
          showMenu: true,
          grupo: "OBRA",
          grupoTitle: "Obra",
        },
      },
      {
        path: "/obra/documentacao",
        name: "Árvore de documentos",
        component: () => import("@/views/Obra/ConfigurarDocumentos.vue"),
        meta: {
          title: "Árvore de documentos",
          icon: "mdi-file-tree",
          subject: ["Obra"],
          action: ["configure"],
          showMenu: true,
          grupo: "OBRA",
          grupoTitle: "Obra",
        },
      },
      {
        path: "/seguros",
        name: "Seguros",
        component: () => import("@/views/Seguros/listarSeguros.vue"),
        meta: {
          obraObrigatoria: true,
          title: "Risco de Engenharia",
          icon: "mdi-clipboard-text-multiple-outline",
          subject: ["SEGUROS"],
          showMenu: true,
          grupo: "seguro",
          grupoTitle: "Seguros",
        },
      },
      {
        path: "/seguros/perfeito",
        name: "Pleno Funcionamento",
        component: () =>
          import("@/views/Seguros/ListarSeguroPerfeitoFuncionamento.vue"),
        meta: {
          obraObrigatoria: true,
          title: "Pleno funcionamento",
          icon: "mdi-clipboard-text-multiple-outline",
          subject: ["SEGUROS_PLENO"],
          showMenu: true,
          grupo: "seguro",
          grupoTitle: "Seguros",
        },
      },
      ...rotasSGI,
      ...rotasProduto,
      ...rotasPosVendas,
      ...rotaContratoAberta,
      ...rotasCRE["geral"],
      ...rotaSemObra,
      ...rotaJuridico,
      ...rotasApontamento
    ],
  },
];

const routes: any = [...rotasAbertas, ...rotasRestritas];
const router = createRouter({
  linkActiveClass: "active",
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
let redirectTo: any = null;

router.afterEach((to, from) => {
  if (
    !ROTAS_IGNORADAS.includes(from.name as string)
  ) {
    if (!ROTAS_IGNORADAS.includes(to.path)) {
      const userStore = useCounterStore();
      userStore.novaRota(to.fullPath);
    }
  }
});

router.beforeEach(async (to, from, next) => {
  // TODO: VERIFICAR ARRAY OBRAS SE VAZIO BUSCAR
  if (to.meta && to.meta.emManutencao) {
    next("/manutencao");
    return;
  }

  converterHashFederado(to, next)

  if (verificarAcesso(pathsAbertos, to, next)) {

    filtrarRotasSeNecessario(from, START_LOCATION)     

    criarBreadcrumbs(to);

    if (!redirecionarUltimaRota(from,to, next))  return next();
  } else {
    next("/403")
  }

//     if (from.name && ["AcessoFederado"].includes(from.name as string)) {
//       const userStore = useCounterStore();
//       if (userStore.ultimaRotaVisitada && !to.redirectedFrom) {
//         
//         if (to.fullPath !== userStore.ultimaRotaVisitada) {
//           next(userStore.ultimaRotaVisitada);
//           return;
//         }
//       }
//     }
//     next();
//   }
//     if (!redirecionarUltimaRota(from,to, next))  next();
//   } 
});

const pathsAbertos = [...rotasAbertas].map((rota) => {
  return rota.path;
});

export default router;
